import { Component } from '@verndale/core';

class Banner extends Component {
  constructor(el: HTMLElement) {
    super(el);

    this.setBackground();
    this.closeBanner();
    document.body.classList.add('with-banner');
  }

  setupDefaults() {
    this.dom = {
      closeButton: this.el.querySelector<HTMLElement>('.banner__close')
    };
  }

  setBackground() {
    const color = this.el.dataset.color || 'white';
    this.el.style.backgroundColor = color;
  }

  closeBanner() {
    if (this.dom.closeButton instanceof HTMLElement) {
      this.dom.closeButton.addEventListener('click', () => {
        this.el.style.display = 'none';
        document.body.classList.remove('with-banner');
      });
    }
  }
}

export default Banner;
